import {
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Tooltip,
} from "@mui/material";
import { Link } from "react-router-dom";

import SideBarSubMenu from "components/Navigation/SideBarSubMenu";

import styles from "./SidebarItem.module.css";

const SidebarItem = ({
    icon: Icon,
    label,
    link,
    isActive,
    isExpanded,
    hasSubItems,
    subItems,
    subItemsLabel,
    isExternal,
}) => {
    return (
        <div
            className={styles.SidebarItemWrapper}
            data-testid={`sidebar-item-${label.toLowerCase().replace(/\s/g, "-")}`}
        >
            {label === "Support" && <hr className={styles.Sidebar_Divider} />}
            <Tooltip
                title={label}
                placement="right"
                disableHoverListener={isExpanded || hasSubItems}
                disableFocusListener={isExpanded || hasSubItems}
                disableTouchListener={isExpanded || hasSubItems}
                classes={{
                    tooltip: styles.SidebarItem_Tooltip,
                    popper: styles.SidebarItem_TooltipPopper,
                }}
                PopperProps={{
                    modifiers: [
                        {
                            name: "offset",
                            options: {
                                offset: [0, 0],
                            },
                        },
                    ],
                }}
            >
                <ListItemButton
                    component={isExternal ? "a" : Link}
                    to={isExternal ? undefined : link}
                    href={isExternal ? link : undefined}
                    target={isExternal ? "_blank" : undefined}
                    rel={isExternal ? "noopener noreferrer" : undefined}
                    className={`${styles.SidebarItem} ${isActive ? styles.SidebarItem_Active : ""}`}
                >
                    {Icon && (
                        <ListItemIcon className={styles.SidebarItem_Icon}>
                            <Icon />
                        </ListItemIcon>
                    )}
                    {isExpanded && (
                        <ListItemText
                            className={styles.SidebarItem_Text}
                            primary={label}
                        />
                    )}
                </ListItemButton>
            </Tooltip>
            {hasSubItems && (
                <div className={styles.SubMenuPopout}>
                    <SideBarSubMenu title={subItemsLabel}>
                        {subItems.map((subItem, index) => (
                            <SidebarItem
                                key={index}
                                icon={subItem.icon}
                                label={subItem.label}
                                link={subItem.link}
                                isActive={subItem.isActive}
                                isExpanded={true}
                                isExternal={subItem.isExternal}
                            />
                        ))}
                    </SideBarSubMenu>
                </div>
            )}
            {label === "Home" && <hr className={styles.Sidebar_Divider} />}
        </div>
    );
};

export default SidebarItem;
